import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import "assets/scss/website/app.scss";
import { AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import FileUpload from "./file-upload/file-upload.component";
import { useTranslation } from "react-i18next";
import plusIcon from "../../../../../assets/images/website/createResale/plus.png";
import playIcon from "../../../../../assets/images/website/createResale/play.png";

const PhotoStep = (props) => {
	const { goBackHandler, stateData, updateStateHandler, setModal } = props;
	const [upload, setUpload] = useState(false);
	const { t } = useTranslation();
	const [formData, setFormData] = useState({
		images_ids: [],
		videos_ids: [],
		mediaIds: [],
		videosIds: [],
	});

	useEffect(() => {
		setFormData({
			images_ids: stateData.images_ids,
			mediaIds: [...stateData.mediaIds],
			videos_ids: [...stateData.videos_ids],
			videosIds: [...stateData.videosIds],
		});
	}, []);

	const updatedAttachment = (attachments) => {
		const ids = attachments.map((res) => res.id);
		setFormData({
			...formData,
			images_ids: [...formData.images_ids, ...ids],
			mediaIds: [...formData.mediaIds, ...attachments],
		});
	};

	const updatedVideos = (attachments) => {
		attachments.map((item) => {
			setFormData({
				...formData,
				videos_ids: [...formData.videos_ids, item.id],
				videosIds: [...formData.videosIds, ...attachments],
			});
		});
	};

	const deleteAttachment = (Items) => {
		let updatedimgs = formData.images_ids?.filter(
			(item) => item !== Items[0].id
		);
		let updatedMedia = formData.mediaIds?.filter(
			(item) => item.id !== Items[0].id
		);
		setFormData({
			...formData,
			images_ids: updatedimgs,
			mediaIds: updatedMedia,
		});
	};
	const deleteVideos = (Items) => {
		let updatedVideosIds = formData.videos_ids?.filter(
			(item) => item != Items[0].id
		);
		let updatedVideos = formData.videosIds?.filter(
			(item) => item.id != Items[0].id
		);
		setFormData({
			...formData,
			videos_ids: updatedVideosIds,
			videosIds: updatedVideos,
		});
	};

	const submitFormHandler = () => {
		if (formData.images_ids.length === 0) {
			toast.error(`${t("Unit Photos required")}`);
		} else {
			updateStateHandler(formData);
		}
	};

	return (
		<AvForm onValidSubmit={(e, v) => submitFormHandler()} className="step-one">
			<p className="subtitle">
				{t("Add all photos and videos related to your property")}
			</p>
			<Row>
				<Col md={6}>
					<label>{t("Upload Photos")}</label>
					<FileUpload
						accept=".jpg,.png,.jpeg,.JPG,.PNG,.JPEG"
						attachmentType="media_id"
						icon={plusIcon}
						setUpload={setUpload}
						attachmentData={formData.mediaIds}
						updatedAttachment={updatedAttachment}
						deleteAttachment={deleteAttachment}
						multiple
					/>
				</Col>
				<Col md={6}>
					<label>{t("Upload Videos (Optional)")}</label>
					<FileUpload
						accept="video/mp4,video/x-m4v,video/*"
						attachmentType="videos_id"
						attachmentData={formData.videosIds}
						setUpload={setUpload}
						icon={playIcon}
						updatedAttachment={updatedVideos}
						deleteAttachment={deleteVideos}
						multiple
					/>
				</Col>
			</Row>

			<Row className="my-4">
				<Col md={9}>
					<button
						type="button"
						style={{ borderRadius: "5px", width: "15%" }}
						className="btn btn-light btnHeight cancel text-center"
						onClick={() => setModal(true)}>
						{t("Cancel")}
					</button>
				</Col>
				<Col md={3} className="d-flex justify-content-between">
					<button
						type="button"
						onClick={() => {
							updateStateHandler(formData);
							goBackHandler();
						}}
						className="btn btn-light back btnHeight text-center"
						style={{ borderRadius: "5px", width: "45%" }}>
						{t("Back")}
					</button>
					<button
						type="submit"
						style={{
							borderRadius: "5px",
							width: "45%",
							borderColor: "var(--primary-color)",
							background: "var(--primary-color)",
						}}
						className="btn btn-success next btnHeight text-center "
						disabled={upload}>
						{t("Next")}
					</button>
				</Col>
			</Row>
		</AvForm>
	);
};

export default PhotoStep;
